import { useEffect, useState } from 'react'

import internalApiQueryWrapper from '../core/internalApiQueryWrapper'
import useRegion from './useRegion'

const useLocalWeatherEnabled = () => {
  const { contentfulId } = useRegion()
  const [localWeatherEnabled, setLocalWeatherEnabled] = useState(false)

  useEffect(() => {
    const fetchData = async () => {
      const params = {
        content_type: 'weatherStation',
        'fields.region.sys.id[in]': contentfulId,
        include: 1,
        limit: 1,
        select: 'sys.id'
      }

      const data = await internalApiQueryWrapper('/api/contentful/weather', params)

      if (Object.keys(data).length) {
        setLocalWeatherEnabled(true)
      } else {
        setLocalWeatherEnabled(false)
      }
    }

    fetchData()
  }, [contentfulId])

  return localWeatherEnabled
}

export default useLocalWeatherEnabled
